import { useAuth } from "@app/shared";
import { FC } from "react";
import { DashboardLayout } from "../../layouts";
import { IconLink, Icons, LabeledText, PageContainer } from "../../shared";
import { DropDownMenu } from "../../shared/DropDownMenu";
import { useNavigate } from "react-router-dom";
import { Pages } from "..";

export const AccountDetails: FC = (props) => {
    const auth = useAuth();
    const navigate = useNavigate();

    function navigateToEditProfile(): void {
        navigate(Pages.EditProfile.getUrl());
    }

    function NavigateToPasswordChange(): void {
        navigate(Pages.ChangePassword.getUrl());
    }

    return (
        <DashboardLayout centerChildren="Account Details">
            <PageContainer
                title="Profile Information"
                titleRight={
                    <DropDownMenu>
                        <IconLink Icon={Icons.Edit} onClick={navigateToEditProfile}>
                            Edit Profile
                        </IconLink>
                        <IconLink iconClassName="reset-icon" Icon={Icons.Reset} onClick={NavigateToPasswordChange}>
                            Change Password
                        </IconLink>
                    </DropDownMenu>
                }
            >
                <LabeledText label="Name">{auth.user?.name}</LabeledText>
                <LabeledText label="Email">{auth.user?.email}</LabeledText>
            </PageContainer>
        </DashboardLayout>
    );
};
